import type { ReactNode } from "react";
import { HelpPopover } from "./HelpPopover";

// Checkbox + label + descripcion opcional. Extraido de Configuracion para
// reuso (GlobalSettings y futuras pantallas). La explicacion larga puede ir
// en `help` ("?") en vez de un `desc` siempre visible.
export function ToggleRow({
  checked,
  onChange,
  label,
  desc,
  help,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: ReactNode;
  desc?: ReactNode;
  help?: ReactNode;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-5 w-5 shrink-0 rounded"
      />
      <div>
        <div className="flex items-center gap-1.5 font-medium">
          {label}
          {help && <HelpPopover>{help}</HelpPopover>}
        </div>
        {desc && <div className="text-xs opacity-60">{desc}</div>}
      </div>
    </label>
  );
}
